import { IIconBase } from '..'

const noteBlackIcon = ({
  color = '#333752',
  height = 17,
  width = 16,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/note'>
        <g id='note'>
          <path
            id='Vector'
            d='M13.3333 5.99967V12.4997C13.3333 14.4997 12.14 15.1663 10.6667 15.1663H5.33334C3.86 15.1663 2.66667 14.4997 2.66667 12.4997V5.99967C2.66667 3.83301 3.86 3.33301 5.33334 3.33301C5.33334 3.74634 5.49999 4.11967 5.77332 4.39301C6.04665 4.66634 6.42 4.83301 6.83334 4.83301H9.16667C9.99334 4.83301 10.6667 4.15967 10.6667 3.33301C12.14 3.33301 13.3333 3.83301 13.3333 5.99967Z'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M10.6667 3.33301C10.6667 4.15967 9.99333 4.83301 9.16666 4.83301H6.83333C6.41999 4.83301 6.04664 4.66634 5.77331 4.39301C5.49998 4.11967 5.33333 3.74634 5.33333 3.33301C5.33333 2.50634 6.00666 1.83301 6.83333 1.83301H9.16666C9.58 1.83301 9.95335 1.99968 10.2267 2.27301C10.5 2.54634 10.6667 2.91967 10.6667 3.33301Z'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_3'
            d='M5.33333 9.16699H7.99999'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_4'
            d='M5.33333 11.833H10.6667'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </svg>
  )
}

export default noteBlackIcon
